//TODO: Need to calc dynamic in the future
export const MIN_APR_VALUE = 34
export const MAX_APR_VALUE = 104
